import { render, staticRenderFns } from "./departmentRole.vue?vue&type=template&id=3e2d80d0&"
import script from "./departmentRole.vue?vue&type=script&lang=js&"
export * from "./departmentRole.vue?vue&type=script&lang=js&"
import style0 from "./departmentRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "departmentRole.vue"
export default component.exports